import type {ApiResponse} from "@/scripts/Common/api";
import {defaultFetch, httpMethod} from "@/scripts/Common/api";
import {getToken} from "@/scripts/Common";

const validateCreditorIdChecksum = async (creditorId: string): Promise<ApiResponse<boolean>> => await defaultFetch({
  apiName: 'creditorIdValidation',
  options: {
    method: httpMethod.POST
  },
  bearer: getToken(),
  body: JSON.stringify({ creditorId: creditorId })
});

export {
  validateCreditorIdChecksum
}
